import * as React from "react";
import { AnalyticsTrigger } from "../../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { FormHelper } from "../form-helper/form-helper.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
import { Skeleton } from "../../skeleton/skeleton/skeleton.mjs";
import { SkeletonItem } from "../../skeleton/skeleton-item/skeleton-item.mjs";
const Check = (props) => {
  return /* @__PURE__ */ React.createElement(
    PropsChecker,
    {
      componentName: "Check",
      componentProps: props,
      defaultValueName: "defaultChecked",
      valueName: "checked",
      onChangeNames: "onChange",
      isComponentDisabled: props.disabled
    },
    /* @__PURE__ */ React.createElement(
      AnalyticsTrigger,
      {
        trigger: {
          callback: "onChange",
          id: ([checked]) => "Checkbox - ".concat(checked ? "Check" : "Uncheck", " - ").concat(props.id),
          elementType: "checkbox",
          elementId: props.id,
          interactionType: ([checked]) => "".concat(checked ? "check" : "uncheck")
        }
      },
      /* @__PURE__ */ React.createElement(CheckInner, { ...props })
    )
  );
};
const CheckInner = (props) => {
  const {
    input,
    checked,
    defaultChecked,
    onChange,
    disabled,
    value,
    id,
    labelText,
    children,
    extraContent,
    size = "large",
    employee,
    direction,
    indicatorAlign,
    hideLabel,
    className,
    fullWidthContent,
    required,
    "aria-invalid": ariaInvalid,
    "aria-describedby": ariaDescribedby,
    helpMessage,
    errorMessage,
    successMessage,
    employeeMessage,
    ...rest
  } = props;
  const [innerChecked, setInnerChecked] = React.useState(defaultChecked || false);
  const isChecked = onChange && typeof checked !== "undefined" ? checked : innerChecked;
  const handleChange = () => {
    const nextChecked = !isChecked;
    if (disabled) {
      return;
    }
    if (typeof checked === "undefined") {
      setInnerChecked(nextChecked);
    }
    if (onChange) {
      onChange(nextChecked);
    }
  };
  const BEM = () => {
    const classArray = ["check"];
    if (size) {
      classArray.push("check--".concat(size));
    }
    if (employee) {
      classArray.push("check--employee");
    }
    if (direction) {
      classArray.push("check--".concat(direction));
    }
    if (indicatorAlign) {
      classArray.push("check--indicator-".concat(indicatorAlign));
    }
    if (hideLabel) {
      classArray.push("check--hide-label");
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const getInputClass = () => {
    const classArray = ["check__input"];
    if (input && input.className) {
      classArray.push(input.className);
    }
    return classArray.join(" ");
  };
  const getAriaDescribedBy = () => {
    const arr = [];
    if (ariaDescribedby) {
      arr.push(ariaDescribedby);
    }
    if (helpMessage) {
      arr.push("".concat(id, "-help-message"));
    }
    if (errorMessage) {
      arr.push("".concat(id, "-error-message"));
    }
    if (successMessage) {
      arr.push("".concat(id, "-success-message"));
    }
    if (employeeMessage) {
      arr.push("".concat(id, "-employee-message"));
    }
    return arr.join(" ");
  };
  const checkInnerBEM = () => {
    const classArray = ["check__inner"];
    if (fullWidthContent) {
      classArray.push("check__inner--full-width");
    }
    return classArray.join(" ");
  };
  if ("skeleton" in props) {
    const { skeleton } = props;
    const { lineCount = 1, lineHeight, lineWidth } = skeleton;
    return /* @__PURE__ */ React.createElement(Skeleton, { className: BEM(), label: skeleton.label }, /* @__PURE__ */ React.createElement("div", { className: checkInnerBEM() }, /* @__PURE__ */ React.createElement(SkeletonItem, { className: "check__indicator" }), /* @__PURE__ */ React.createElement("div", { className: "check__content" }, [...Array(lineCount).keys()].map((line) => /* @__PURE__ */ React.createElement(SkeletonItem, { key: line, height: lineHeight, width: lineWidth })))));
  }
  return /* @__PURE__ */ React.createElement("div", { className: BEM(), onClick: (e) => e.stopPropagation(), ...rest }, /* @__PURE__ */ React.createElement(
    "input",
    {
      ...input,
      type: "checkbox",
      checked: isChecked,
      defaultChecked: void 0,
      disabled,
      value,
      onChange: handleChange,
      id,
      className: getInputClass(),
      "aria-invalid": ariaInvalid,
      "aria-describedby": getAriaDescribedBy(),
      "aria-required": required
    }
  ), /* @__PURE__ */ React.createElement("label", { htmlFor: id, className: "check__label" }, labelText), /* @__PURE__ */ React.createElement("div", { className: checkInnerBEM(), onClick: handleChange }, /* @__PURE__ */ React.createElement("span", { className: "check__indicator" }, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#check", className: "check__icon" })), /* @__PURE__ */ React.createElement("div", { className: "check__content", "aria-hidden": !children }, children || labelText)), helpMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "check__form-helper", text: helpMessage, type: "help", id: "".concat(id, "-help-message") }), errorMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "check__form-helper", text: errorMessage, type: "error", id: "".concat(id, "-error-message") }), successMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "check__form-helper", text: successMessage, type: "valid", id: "".concat(id, "-success-message") }), employeeMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "check__form-helper", text: employeeMessage, type: "employee", id: "".concat(id, "-employee-message") }), extraContent && /* @__PURE__ */ React.createElement("div", { className: "check__extra" }, extraContent));
};
export {
  Check
};
